import React, { useState } from "react";
import { Modal, Button, Row, Col, Card, CardBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { AiOutlinePlus } from "react-icons/ai";

const ScanProfileTabPane = ({
  featureName = "Scan Profile",
  checks = [],
  onDelete,
  onSave,
  onAdd,
  onToggleStatus,
}) => {
  const [modalDelete, setModalDelete] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalSave, setModalSave] = useState(false);

  const [activeItem, setActiveItem] = useState({ id: "", keyword: "", risk: "Informational" });
  const [newKeyword, setNewKeyword] = useState("");
  const [newRisk, setNewRisk] = useState("Informational");
  const [changedRisks, setChangedRisks] = useState({});

  const riskOptions = ["Critical", "High", "Medium", "Low", "Informational"];

  const handleRiskDropdown = (id, val) => {
    setChangedRisks((prev) => ({ ...prev, [id]: val }));
  };

  return (
    <div className="feature-scan-profile">
      <Row>
        <Col sm="12" md="8" lg="6">
          <Card className="feature-table-card" style={{ marginBottom: 16 }}>
            <div className="feature-card-header">
              <span>{featureName}</span>
              <div className="form-check form-switch form-switch-md" style={{ margin: 0 }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="profileStatusSwitch"
                  defaultChecked
                  onChange={(e) => onToggleStatus && onToggleStatus(e.target.checked)}
                />
              </div>
            </div>

            <div style={{ padding: "0 16px" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 0" }}>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setModalAdd(true)}
                  style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                >
                  <AiOutlinePlus /> Add String
                </Button>
              </div>

              <div className="feature-table-container">
                <table className="feature-data-table">
                  <thead>
                    <tr>
                      <th>String</th>
                      <th>Risk</th>
                      <th style={{ textAlign: "right" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {checks.length === 0 ? (
                      <tr>
                        <td colSpan="3" style={{ textAlign: "center", color: "var(--fg-secondary)" }}>
                          No scan profile checks configured
                        </td>
                      </tr>
                    ) : (
                      checks.map((c, idx) => {
                        const currentRisk = changedRisks[c.ID] || c.Risk || "Informational";
                        return (
                          <tr key={c.ID || idx}>
                            <td className="mono">{c.Keyword || c.String || "-"}</td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={currentRisk}
                                onChange={(e) => handleRiskDropdown(c.ID, e.target.value)}
                                style={{ width: 140, background: "var(--bg-surface)", color: "var(--fg-primary)", border: "1px solid var(--border-default)" }}
                              >
                                {riskOptions.map((r) => (
                                  <option key={r} value={r}>
                                    {r}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <div className="btn-group btn-group-sm">
                                <Button
                                  color="primary"
                                  outline
                                  size="sm"
                                  onClick={() => {
                                    setActiveItem({ id: c.ID, keyword: c.Keyword || c.String, risk: currentRisk });
                                    setModalSave(true);
                                  }}
                                >
                                  Save
                                </Button>
                                <Button
                                  color="danger"
                                  outline
                                  size="sm"
                                  onClick={() => {
                                    setActiveItem({ id: c.ID, keyword: c.Keyword || c.String, risk: currentRisk });
                                    setModalDelete(true);
                                  }}
                                >
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Delete Modal */}
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Confirm Delete</h5>
          <button type="button" className="btn-close" onClick={() => setModalDelete(false)} />
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete check for string: <strong>{activeItem.keyword}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => setModalDelete(false)}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={() => {
              if (onDelete) onDelete(activeItem.id, activeItem.keyword);
              setModalDelete(false);
            }}
          >
            Delete
          </Button>
        </div>
      </Modal>

      {/* Save Modal */}
      <Modal isOpen={modalSave} toggle={() => setModalSave(!modalSave)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Confirm Update</h5>
          <button type="button" className="btn-close" onClick={() => setModalSave(false)} />
        </div>
        <div className="modal-body">
          <p>
            Update risk level for <strong>{activeItem.keyword}</strong> to <strong>{activeItem.risk}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => setModalSave(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (onSave) onSave(activeItem.id, activeItem.keyword, activeItem.risk);
              setModalSave(false);
            }}
          >
            Save Changes
          </Button>
        </div>
      </Modal>

      {/* Add Modal */}
      <Modal isOpen={modalAdd} toggle={() => setModalAdd(!modalAdd)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Add Check String</h5>
          <button type="button" className="btn-close" onClick={() => setModalAdd(false)} />
        </div>
        <AvForm
          onValidSubmit={(_, vals) => {
            if (onAdd) onAdd(vals.keyword, vals.risk);
            setModalAdd(false);
          }}
        >
          <div className="modal-body">
            <AvField
              name="keyword"
              label="Check String / Keyword"
              type="text"
              placeholder="e.g. admin or 443"
              required
              errorMessage="Please enter a string"
            />
            <AvField name="risk" label="Risk Level" type="select" value={newRisk} required>
              {riskOptions.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </AvField>
          </div>
          <div className="modal-footer">
            <Button color="secondary" type="button" onClick={() => setModalAdd(false)}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Add Check
            </Button>
          </div>
        </AvForm>
      </Modal>
    </div>
  );
};

export default ScanProfileTabPane;
